import { createContext, useContext } from 'react'
import { gql, useQuery } from '@apollo/client'

export const SOCIAL_INFO_QUERY = gql`
  query($broadcastId: String!) {
    socialInfo(broadcastId: $broadcastId) {
      accessMetrics {
        latestViewers
      }
      clickingMetrics {
        products
      }
    }
  }
`

const SocialInfoContext = createContext({ data: null })

export default SocialInfoContext

const useSocialInfo = () => useContext(SocialInfoContext)

function useSocialInfoProvider (broadcastId: string, shouldSkip = false) {
  return useQuery(SOCIAL_INFO_QUERY, {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
    pollInterval: 60000,
    variables: { broadcastId },
    skip: shouldSkip
  })
}

export { useSocialInfoProvider, useSocialInfo }
